// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.school-list-container {
  background-color: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  padding: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.school-list-title-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  width: 100%;
}

.school-list-title {
  font-size: 2.6rem;
  font-weight: bold;
  font-family: serif;
  background: linear-gradient(135deg,#664400,#996600, #f2e5b3, #cc9933, #996600, #664400, #f2e5b3);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  letter-spacing: 0.05em;
  margin: 0 1rem;
}

.award-icon {
  width: 3rem;
  height: 3rem;
}

.school-item {
  display: flex;
  align-items: center;
  margin-bottom: 0.25rem;
  padding: 0.1rem 0.1rem;
}

.school-icon {
  width: 2rem;
  height: 2rem;
  margin-right: 0.5rem;
}

.school-name {
  font-size: 1.8rem;
  font-family: serif;
  color: #333;
  font-weight: 500;
}

.toggle-text {
  cursor: pointer;
  text-align: center;
  font-size: 1rem;
  margin-top: 1rem;
}

.toggle-text:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .school-list-container {
    justify-content: center;
  }

  .school-item {
    flex: 1 1 100%;
    justify-content: flex-start;
  }

  .award-icon {
    width: 2.5rem;
    height: 2.5rem;
  }

  .school-list-title {
    font-size: 2rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/SchoolList.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,aAAa;EACb,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gGAAgG;EAChG,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".school-list-container {\n  background-color: #f9f9f9;\n  border-radius: 10px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  max-width: 100%;\n  padding: 1rem;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.school-list-title-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1.5rem;\n  width: 100%;\n}\n\n.school-list-title {\n  font-size: 2.6rem;\n  font-weight: bold;\n  font-family: serif;\n  background: linear-gradient(135deg,#664400,#996600, #f2e5b3, #cc9933, #996600, #664400, #f2e5b3);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  letter-spacing: 0.05em;\n  margin: 0 1rem;\n}\n\n.award-icon {\n  width: 3rem;\n  height: 3rem;\n}\n\n.school-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.25rem;\n  padding: 0.1rem 0.1rem;\n}\n\n.school-icon {\n  width: 2rem;\n  height: 2rem;\n  margin-right: 0.5rem;\n}\n\n.school-name {\n  font-size: 1.8rem;\n  font-family: serif;\n  color: #333;\n  font-weight: 500;\n}\n\n.toggle-text {\n  cursor: pointer;\n  text-align: center;\n  font-size: 1rem;\n  margin-top: 1rem;\n}\n\n.toggle-text:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 768px) {\n  .school-list-container {\n    justify-content: center;\n  }\n\n  .school-item {\n    flex: 1 1 100%;\n    justify-content: flex-start;\n  }\n\n  .award-icon {\n    width: 2.5rem;\n    height: 2.5rem;\n  }\n\n  .school-list-title {\n    font-size: 2rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
